import { render } from "./AssetStatusMessage.vue?vue&type=template&id=0f2ee87c"
import script from "./AssetStatusMessage.vue?vue&type=script&lang=js"
export * from "./AssetStatusMessage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/ui/components/AssetStatusMessage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0f2ee87c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0f2ee87c', __exports__)) {
    api.reload('0f2ee87c', __exports__)
  }
  
  module.hot.accept("./AssetStatusMessage.vue?vue&type=template&id=0f2ee87c", () => {
    api.rerender('0f2ee87c', render)
  })

}


export default __exports__